import React from 'react';
import styles from './ProfessorDashboard.module.css';

function PaginationControls({ currentPage, totalPages, onPageChange }) {
  const generatePageNumbers = () => {
    return Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
      let pageNum;
      if (totalPages <= 5) {
        pageNum = i + 1;
      } else if (currentPage <= 3) {
        pageNum = i + 1;
      } else if (currentPage >= totalPages - 2) {
        pageNum = totalPages - 4 + i;
      } else {
        pageNum = currentPage - 2 + i;
      }
      return pageNum;
    });
  };

  return (
    <div className={styles.paginationContainer}>
      <div className={styles.paginationWrapper}>
        <div className={styles.paginationControls}>
          <button
            onClick={() => onPageChange(Math.max(currentPage - 1, 1))}
            disabled={currentPage === 1}
            className={styles.paginationButton}
          >
            <svg className={`${styles.paginationButtonIcon} ${styles.paginationButtonIconLeft}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
            Previous
          </button>
          
          <div className={styles.paginationNumbers}>
            {generatePageNumbers().map(pageNum => (
              <button
                key={pageNum}
                onClick={() => onPageChange(pageNum)}
                className={`${styles.pageNumberButton} ${
                  currentPage === pageNum ? styles.pageNumberButtonActive : styles.pageNumberButtonInactive
                }`}
              >
                {pageNum}
              </button>
            ))}
          </div>
          
          <button
            onClick={() => onPageChange(Math.min(currentPage + 1, totalPages))}
            disabled={currentPage === totalPages}
            className={styles.paginationButton}
          >
            Next
            <svg className={`${styles.paginationButtonIcon} ${styles.paginationButtonIconRight}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          </button>
        </div>
        
        <div className={styles.paginationInfo}>
          Page <span className={styles.paginationInfoBold}>{currentPage}</span> of{' '}
          <span className={styles.paginationInfoBold}>{totalPages}</span>
        </div>
      </div>
    </div>
  );
}

export default PaginationControls;